import React, { useState, useCallback } from "react"
import clsx from 'clsx'
import { CabecalhoLogo } from "../cabecalho-logo/CabecalhoLogo"
import * as R from 'ramda'
import globalMU from "globalMU"

const estilosSenhaVendedor = require('./senha-vendedor.module.scss').default
const estilosBotoes = require('../../estilos/botoes.module.scss').default
const estilosInputs = require('../../estilos/inputs.module.scss').default
const estilosCaixaDialogoPadrao = require('../../estilos/caixa-dialogo-padrao.module.scss').default
const tipografia = require("../../components/estilos-reutilizaveis/tipografia.module.scss").default;


export type SenhaVendedorProps = {
    onSenhaInformada: (senha: string) => void
    onCancelar: () => void
    onAlterarSenha: () => void
    exibirBotaoAlterarSenha: boolean
    urlLogo?: string
    realizandoProcessamento: boolean;
}

export const SenhaVendedor = (props: SenhaVendedorProps) => {
    const [senha, setSenha] = useState("")
    const [isCapsLockOn, setIsCapsLockOn] = useState(false)

    const checkCapsLock = useCallback((event) => {
        if (event && typeof event.getModifierState === 'function') {
            setIsCapsLockOn(event.getModifierState('CapsLock'));
          }
    }, [])

    const handleSenhaChange = useCallback((e) => {
        setSenha(e.target.value)
    }, [])

    const handleSenhaKeyDown = useCallback((e) => {
        if (R.includes(e.code, ["Enter", "NumpadEnter"])) {
			e.preventDefault() // sem isso o Enter dispara submit implicito do <form>, 
            if (senha?.length ==0){
                globalMU.showErrorMessage("Informe a senha")
                return
            }
            props.onSenhaInformada(senha)
        }
    }, [senha, props.onSenhaInformada])

    const handleBlur = useCallback(() => {
        setIsCapsLockOn(false)
    }, [])

    const handleClickSenha = useCallback(() => {
        if (senha?.length === 0) {
            globalMU.showErrorMessage("Informe a senha")
            return
        }
        props.onSenhaInformada(senha)
    }, [senha, props.onSenhaInformada])

    // useEffect(() => {
    //     document.getElementById("senha-vendedor-input").focus()
    // }, [])

    return (
        <div
            className={clsx(estilosCaixaDialogoPadrao.container, estilosCaixaDialogoPadrao.caixaFlutuante)}
            id="SenhaVendedor_Container"
        >
            <CabecalhoLogo urlLogo={props.urlLogo} />

            <div className={estilosCaixaDialogoPadrao.corpo}
                id="SenhaVendedor_Corpo"
            >
                <div className={estilosSenhaVendedor.dica}>
                    <span className={tipografia.dicaUsuario}
                        id="SenhaVendedor_Dica"
                    >Dica: se você esqueceu sua senha peça para o administrador alterá-la.</span>
                </div>

                
                        {/* Input escondido para enganar o Chrome  para nao pedir para gravar senha */}
                        <input 
                            type="text" 
                            name="fakeUsername" 
                            style={{ display: 'none' }}
                        />
                        <input 
                            type="password" 
                            name="fakePassword" 
                            style={{ display: 'none' }}
                        />
                        {/* FIM- Input escondido para enganar o Chrome */}


                <div className="_flex _flex-row _gap-x-4 _ml-8">
                    <span>Senha</span>

                    <div className="_flex _flex-col _gap-y-2">
                        <form>
                        <input className={estilosInputs.inputPadrao}
                            id="senha-vendedor-input"
                            disabled={props.realizandoProcessamento}
                            onKeyUp={checkCapsLock}
                            onFocus={checkCapsLock}
                            autoComplete="vendedor-password" // para naos mostrar dados digitados anteriormente
                            aria-autocomplete="none"
                            list="autocompleteOff" // para naos mostrar dados digitados anteriormente
                            onBlur={handleBlur}
                            onChange={handleSenhaChange}
                            onKeyDown={handleSenhaKeyDown}
                            autoFocus
                            name="data-password"
                            type="password"
                        />
                        </form>
                        <div className="_flex _flex-row _gap-x-4">
                            <button className={estilosBotoes.botaoPrimario}
                                id="SenhaVendedor_BotaoOk"
                                disabled={props.realizandoProcessamento}
                                onClick={handleClickSenha}
                                onFocus={handleBlur}
                            >{props.realizandoProcessamento ? "Aguarde..." : "Ok"}
                            </button>
                            <button className={estilosBotoes.botaoPrimario}
                                onFocus={handleBlur}
                                id="SenhaVendedor_BotaoCancelar"
                                onClick={props.onCancelar}>Cancelar</button>

                            {props.exibirBotaoAlterarSenha && <button className={estilosBotoes.botaoPrimario}
                                id="SenhaVendedor_AlteararSenha"
                                onClick={props.onAlterarSenha}>Alterar Senha</button>}
                        </div>
                    </div>
                    {isCapsLockOn && (
                        <span
                            style={{ color: "red", fontWeight: "bold", }}>CapsLock está ativado</span>
                    )}
                </div>
            </div>
        </div>
    )
}

(window as any).SenhaVendedor = SenhaVendedor
